import { render, staticRenderFns } from "./CopyCompoundModal.vue?vue&type=template&id=a7238b14"
import script from "./CopyCompoundModal.vue?vue&type=script&lang=js"
export * from "./CopyCompoundModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports